import { Heart, Users, Grid3x3 } from "lucide-react";

/**
 * Interactive-gallery view selector — segmented pill control rendered into
 * the gallery header. Three modes:
 *   "all"      — show the full gallery (default; no filter applied)
 *   "mine"     — show only photos *I* have hearted
 *   "everyone" — show only photos hearted by anyone (>=1 vote)
 *   "heatmap"  — show all photos sorted by descending vote count
 *
 * Default is "all" so the gallery doesn't disappear when nothing's been
 * favorited yet. Cream/charcoal/gold editorial palette, no red.
 */
export default function FavoritesViewToggle({ value = "all", onChange, counts = {} }) {
  const options = [
    { id: "all",      label: "All",       icon: Grid3x3 },
    { id: "mine",     label: "My Picks",  icon: Heart   },
    { id: "everyone", label: "Everyone",  icon: Users   },
    { id: "heatmap",  label: "Heatmap",   icon: Heart   },
  ];

  return (
    <div
      className="inline-flex items-center bg-stone-900/5 border border-stone-900/10 p-0.5 rounded-sm"
      role="tablist"
      data-testid="favorites-view-toggle"
    >
      {options.map((o) => {
        const Icon = o.icon;
        const active = value === o.id;
        const count = counts[o.id];
        return (
          <button
            key={o.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(o.id)}
            className={[
              "inline-flex items-center gap-1.5 px-3 sm:px-4 h-8 text-[10px] uppercase tracking-[0.22em] transition-all rounded-sm",
              active
                ? "bg-stone-900 text-[#F5EFE0]"
                : "text-stone-700 hover:text-stone-900 hover:bg-stone-900/5",
            ].join(" ")}
            data-testid={`fav-view-${o.id}`}
          >
            <Icon className="w-3 h-3" strokeWidth={active ? 2 : 1.5} />
            <span>{o.label}</span>
            {typeof count === "number" && count > 0 && (
              <span className={`ml-1 text-[9px] ${active ? "text-[#C9A961]" : "text-stone-500"}`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
